module.exports = __webpack_public_path__ + "img/pop_hong@2x.207d1ad5.png";